import axios from 'axios';

export const logBugOnServer = async (name, message) => {
	await axios.post('/api/debug/log', { name, message });
};
